import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { getControleDeAcesso } from 'util/AuthUtils';
import { decrypt } from 'util/cobUtils';

const PrivateRoute = ({ component: Component, codigo, ...rest }) => {
  try {
    // consulta no localstorage
    let authUserInfo = localStorage.getItem('access');
    authUserInfo = decrypt(authUserInfo);
    authUserInfo = JSON.parse(authUserInfo);

    return (
      <Route
        {...rest}
        render={(props) => {
          const acesso = getControleDeAcesso(codigo, authUserInfo);
          if (acesso == false) {
            return (
              <Redirect
                to={{
                  pathname: '/app/acesso-negado',
                  state: { from: props.location },
                }}
              />
            );
          }

          // autorizado
          return <Component {...props} />;
        }}
      />
    );
  } catch (error) {
    return (
      <Route
        {...rest}
        render={(props) => {
          return (
            <Redirect
              to={{
                pathname: '/app/acesso-negado',
                state: { from: props.location },
              }}
            />
          );
        }}
      />
    );
  }
};

export default PrivateRoute;
